// One team on stage, seen from the crowd (diagram 1 of docs/plans/ext-teams-seating.md, drawn with
// the crowd at the bottom so the screen's left is the crowd's left). Seats 1–5 left to right; each
// seat is a dropdown of the team's players, the unseated players are the substitutes.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { S, SeatUnit, Crowd, SeatCard, SubsBox, swapSeat } from './StageArt';

const W = 1100, H = 500;
const SEAT_X = [110, 280, 450, 620, 790];

export default function TeamStage({ teamName, tint, players, seats, onChange, readOnly }) {
  const { t } = useTranslation();
  const ign = Object.fromEntries(players.map(p => [p.steam_id, p.ign]));
  const subs = players.filter(p => !seats.includes(p.steam_id));
  // Per seat: other seated players show their seat ("swap"), unseated ones show "sub"; the seat's own player shows nothing.
  const optionsFor = (i) => players.map(p => {
    const at = seats.indexOf(p.steam_id);
    return { value: p.steam_id, label: p.ign, sub: at === i ? null : at >= 0 ? t('extSeating.seatN', 'seat {{n}}', { n: at + 1 }) : t('extSeating.subShort', 'sub') };
  });
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto', display: 'block' }} role="img" aria-label={t('extSeating.teamStageAria', 'Stage seating of {{team}}, seen from the crowd', { team: teamName })}>
      <text x={450} y={34} textAnchor="middle" fontSize="20" fontWeight="800" fill={tint} style={{ fontFamily: "var(--font-display, 'Cabinet Grotesk', sans-serif)" }}>{teamName}</text>
      {/* stage platform; the front edge faces the crowd */}
      <rect x={30} y={52} width={840} height={280} rx={14} fill={S.card} stroke={S.line2} strokeWidth="1.2" />
      <line x1={30} y1={330} x2={870} y2={330} stroke={S.line3} strokeWidth="3" strokeLinecap="round" />
      <text x={850} y={322} textAnchor="end" fontSize="10" fontWeight="700" letterSpacing="0.08em" fill={S.muted} style={{ textTransform: 'uppercase' }}>{t('extSeating.stageFront', 'Stage front')}</text>
      {SEAT_X.map((x, i) => <SeatUnit key={i} x={x} y={258} angle={180} scale={1.45} tint={tint} filled={!!seats[i]} />)}
      {SEAT_X.map((x, i) => (
        <foreignObject key={`c${i}`} x={x - 68} y={84} width={136} height={70}>
          <SeatCard n={i + 1} tint={tint} value={seats[i]} options={optionsFor(i)} readOnly={readOnly} emptyLabel={t('extSeating.emptySeat', 'Pick a player')}
            onChange={(sid) => onChange(swapSeat(seats, i, sid))} style={{ width: 136 }} />
        </foreignObject>
      ))}
      <Crowd x={170} y={410} w={560} h={76} label={t('extSeating.crowd', 'Crowd')} />
      <foreignObject x={905} y={92} width={180} height={240}>
        <SubsBox title={t('extSeating.substitutes', 'Substitutes')} tint={tint} players={subs.map(p => ({ steam_id: p.steam_id, ign: ign[p.steam_id] }))} emptyLabel={t('extSeating.noSubs', 'None')} />
      </foreignObject>
    </svg>
  );
}
